if(window.location.hash && window.location.hash === "#prijs-berekenen") {
    let calculatePriceButton = _.head(document.querySelectorAll('.region-content a[href="/prijs-berekenen"]'));

    if (!_.isEmpty(calculatePriceButton)) {
        setTimeout(() => {
            calculatePriceButton.click();
        }, 250);
    }
}

const c2aInput = document.getElementById('map-c2a-input');
const c2aButton = document.getElementById('map-c2a-button');

let goToGarages = function () {
    window.location = '/vestigingen';
}

if (c2aInput) {
    c2aInput.onfocus = function () {
        goToGarages();
    }
}

if (c2aButton) {
    c2aButton.onclick = function () {
        goToGarages();
    }
}

const occasionGeoObject = document.getElementById('geo-lat-lng');

if ( occasionGeoObject ) {
    const lat = occasionGeoObject.getAttribute('data-geo-lat');
    const lng = occasionGeoObject.getAttribute('data-geo-lng');

    let googleLink = `https://www.google.com/maps/?q=${lat},${lng}`;

    let links = document.querySelectorAll('.occasion-detail-layout .view-occassion-garage.view-display-id-block_2 .view-content .views-row .views-field:not(.views-field-nothing)');

    Array.from(links).forEach(link => {
        link.onclick = function() {
            window.open(googleLink, '_blank');
        }
    });
}

const newsTeasers = document.querySelectorAll('.view-laatste-nieuws .teaser-item');

if (! _.isEmpty(newsTeasers)) {
    Array.from(newsTeasers).forEach(teaser => {
        let teaserUrl = teaser.querySelector('.field--name-node-link').getElementsByTagName('a')[0].getAttribute('href');

        teaser.onclick = function() {
            window.location = teaserUrl;
        }
    });
}

const vacatureTeasers = document.querySelectorAll('.view-vacatures .views-row');

if (! _.isEmpty(vacatureTeasers)) {
    Array.from(vacatureTeasers).forEach(teaser => {
        let teaserUrl = teaser.querySelector('.views-field-view-node').getElementsByTagName('a')[0].getAttribute('href');

        teaser.onclick = function() {
            window.location = teaserUrl;
        }
    });
}

const specialismeItems = document.querySelectorAll('.view-specialismes.view-display-id-block_2 .views-row');

if (! _.isEmpty(specialismeItems)) {
    Array.from(specialismeItems).forEach(item => {
        let itemUrl = item.querySelector('.views-field-title')?.getElementsByTagName('a')[0]?.getAttribute('href');

        item.onclick = function() {
            window.location = itemUrl;
        }
    });
}

const kentekenInput = document.querySelector('.kentekenplaat');

function formatKentekenPlaat(element) {
    if (_.isNil(element)) {
        return;
    }

    element.addEventListener('input', function (event) {
        let kentekenNummer = event.target.value.replace(/\.|\-/g, "");

        if (kentekenNummer.length > 7) {
            kentekenNummer = kentekenNummer.slice(0, 7);
        }

        if (_.isEqual(kentekenNummer.length, 5)) {
            event.target.value = `${kentekenNummer.slice(0,2)}.${kentekenNummer.slice(2,5)}`
            return;
        }

        if (_.isEqual(kentekenNummer.length, 6)) {
            event.target.value = `${kentekenNummer.slice(0,3)}-${kentekenNummer.slice(3,6)}`
            return;
        }

        if (_.isEqual(kentekenNummer.length, 7)) {
            event.target.value = `${kentekenNummer.slice(0,1)}-${kentekenNummer.slice(1,4)}-${kentekenNummer.slice(4,7)}`
        }
    })
}

if (!lodash.isNil(kentekenInput)) {
    //new Kentekenplaat(document.querySelector('.kentekenplaat'));
    formatKentekenPlaat(document.querySelector('.kentekenplaat'))
}

Drupal.behaviors.afspraakMakenDialog = {
    attach: function (context, settings) {
        // Using once() with more complexity.
        jQuery(once('kentekenplaat', 'input.kentekenplaat', context)).each(function () {
            //new Kentekenplaat(document.querySelector('.kentekenplaat'));
            formatKentekenPlaat(document.querySelector('.kentekenplaat'))
        });
    }
};

let buttonClose404 = document.querySelector('button.close-404-message');
let Occasion404Message = document.querySelector('div.view-id-404_occasion_message');

if (! lodash.isNil(buttonClose404)) {
    buttonClose404.addEventListener('click', () => {
        Occasion404Message.parentNode.removeChild(Occasion404Message);
    });
}

if (!lodash.isNil(document.querySelector('header.navigation'))) {
    document.documentElement.style.setProperty('--navigation-height', document.querySelector('header.navigation').offsetHeight + 'px')
}

let checkForFixedButtons = (buttons) => {
    let isMobile = window.matchMedia('(max-width: 768px)').matches
    const regionContent = document.querySelector('.region.region-content');

    if (_.isEmpty(buttons) || !isMobile || lodash.isNil(regionContent)) {
        return;
    }

    const fixedButtonWrapper = document.createElement("div");
    fixedButtonWrapper.classList.add('fixed-cta-buttons')
    regionContent.appendChild(fixedButtonWrapper);

    let fixedCtaButtons = regionContent.querySelector('.fixed-cta-buttons');

    buttons.forEach((button) => {
        fixedCtaButtons.appendChild(button.cloneNode(true));
    });

    const headerTextBlock = document.querySelector('.paragraph--type-header .header-text-block');

    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
    };

    const callback = (entries, observer) => {
        let fixedCtaButtons = regionContent.querySelector('.fixed-cta-buttons');

        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                fixedCtaButtons.classList.remove('on-screen');
                document.body.classList.remove('fixed-padding');
                document.body.style.paddingBottom = 'unset';
                return;
            }

            fixedCtaButtons.classList.add('on-screen');
            document.body.style.paddingBottom = fixedCtaButtons.offsetHeight + 'px';
        })
    }

    const observer = new IntersectionObserver(callback, options);
    observer.observe(headerTextBlock);
}

const headerCtaButtons = document.querySelectorAll('.paragraph--type-header .header-text-block a[class*="btn-arrow"]');
checkForFixedButtons(headerCtaButtons);

let officeHoursComments = document.querySelectorAll('.office-hours__item-comments');
if (!_.isNil(officeHoursComments)) {
    officeHoursComments.forEach((comment) => {
        if (comment.innerHTML === ' &amp; ') {
            comment.style.display = 'none';
        }
    });
}